<template>
  <div class="mdc-layout-grid__inner">
    <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
      <p class="mdc-typography--title">Hi!</p>
      <p class="mdc-typography--body1">
        I'm Ajay Addepalle, passionate about software technology, video games. Have a look around my website if any of
        these topics interest you.
        <br/>
        <br/>
        <span class="mdc-typography--caption">
          For correspondence, head over to the
          <router-link to="/contact" class="mdc-typography--caption">Contact</router-link>
          page.
        </span>
      </p>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    computed: {
      ...mapGetters(
        {
          navLinks: 'getCount',
          hasNavLinks: 'hasNavLinks'
        }
      ),
      msg: () => {
        return 'Hello World'
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// Home.vue?641f160a